import { StyletronComponent } from 'styletron-react';
import { styled, useStyletron } from '../../Themes';
import React from 'react';

export const headerRootStyles = (props: any) => {
	return {
		display: 'flex',
		justifyContent: 'space-between',
		borderBottomWidth: '2px',
		borderBottomStyle: 'solid',
		borderBottomColor: 'var(--epods--color-border)',
		height: 'var(--epods--header-container-height)',
		alignItems: 'center',
		position: 'relative',
		backgroundColor: props.backgroundColor,
		color: 'var(--epods--color-text-primary)',
		zIndex: props.zIndex,
	};
};